import api from './axiosInstance';

export interface AppNotification {
  _id: string;
  type: string;
  title: string;
  message: string;
  link?: string;
  read: boolean;
  createdAt: string;
}

export const fetchNotifications = async () => {
  const { data } = await api.get<{ notifications: AppNotification[]; unreadCount: number }>(
    '/notifications'
  );
  return data;
};

export const markNotificationRead = async (id: string) => {
  const { data } = await api.patch(`/notifications/${id}/read`);
  return data;
};

export const markAllNotificationsRead = async () => {
  const { data } = await api.patch('/notifications/read-all');
  return data;
};
